import { TopPage } from './top.page';

export default TopPage;
